exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js!./../assets/style/main.scss"), "");

// module
exports.push([module.id, "", ""]);

// exports
